import { combineReducers } from 'redux'
import { handleActions } from 'redux-actions'

export const errorCode = handleActions({}, null)

export default combineReducers({
  errorCode
})
